import { render, staticRenderFns } from "./StudentDetailHeader.vue?vue&type=template&id=7e596c40"
import script from "./StudentDetailHeader.vue?vue&type=script&lang=js"
export * from "./StudentDetailHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports